import { render, staticRenderFns } from "./course_recharge_list.vue?vue&type=template&id=18423e8d&scoped=true"
import script from "./course_recharge_list.vue?vue&type=script&lang=js"
export * from "./course_recharge_list.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/course-account.scss?vue&type=style&index=0&id=18423e8d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18423e8d",
  null
  
)

export default component.exports